module.exports = __webpack_public_path__ + "static/takamol-logo-white-fdd748ec98a2d1d1dec2d8da8bc7eaec.png";